import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'

const InvoiceTypeModal = props => {
  return (
    <React.Fragment>
      {props.open && (
        <Dialog open onClose={props.onClose}>
          <DialogTitle id="confirmation-dialog-title">Elija tipo de factura</DialogTitle>
          <DialogContent>
            <MenuList style={{ marginTop: -10, marginBottom: 10 }}>
              <MenuItem onClick={props.openInvoiceGroupedByProduct}>Agrupada por producto</MenuItem>
              <MenuItem onClick={props.openInvoiceGroupedByGreenhouse}>Agrupada por finca y nave</MenuItem>
              <MenuItem onClick={props.openInvoiceGroupedByDelivery}>Agrupada por albarán</MenuItem>
            </MenuList>
          </DialogContent>
        </Dialog>
      )}
    </React.Fragment>
  )
}

const styles = {}

export default withStyles(styles)(InvoiceTypeModal)



// WEBPACK FOOTER //
// ./src/components/InvoiceTypeModal.js